import * as PointsActions from '../actions/points.actions';
import * as PointsApiActions from '../actions/points-api.actions';
import { Point } from '../../../tracks/models/point';
import { PointsSummary } from '../../../tracks/models/points-summary';


export interface State {
  pointsMap: Map<number, Map<string, PointsSummary>>;
  points: {[key: number]: Partial<PointsSummary>}
  error: any;
  pointsLoading: boolean;
  selectedPoint: Point,
  pointsViewer: Point[]
}


export const initialState: State = {
  pointsMap: new Map<number, Map<string, PointsSummary>>(),
  points: null,
  error: null,
  pointsLoading: false,
  selectedPoint: null,
  pointsViewer: []
};


export function reducer(
  state = initialState,
  action: PointsActions.PointsActionsUnion | PointsApiActions.PointsApiActionsUnion
): State {
  switch (action.type) {
    case PointsActions.getPoints.type: {
      return {
        ...state,
        pointsLoading: true,
      }
    }
    case PointsApiActions.getPointsSuccess.type: {
      if (!action.unitIds) {
        return {
          ...state
        }
      }
      const newMap = new Map<number, Map<string, PointsSummary>>(state.pointsMap);
      const params = JSON.stringify({dateFrom: action.params.dateFrom, dateTo: action.params.dateTo });
      const points = {};
      if (action.unitIds) {
        action.unitIds?.forEach((unitId: number, index: number) => {
          const data = action.data[index];
          if (!newMap.has(unitId)) {
            newMap.set(unitId, new Map<string, PointsSummary>())
          }
          newMap.get(unitId).set(params, data);
          points[unitId] = data;
        });
      }
      return {
        ...state,
        pointsMap: newMap,
        points: points,
        pointsLoading: false,
      };
    }
    case PointsApiActions.getPointsFailure.type: {
      return {
        ...state,
        error: action.error,
        points: null,
        pointsLoading: false,
      };
    }
    case PointsActions.clearCache.type: {
      state.pointsMap.clear();
      state.points = null;
      return {
        ...state
      };
    }
    case PointsActions.selectPoint.type: {
      return {
        ...state,
        selectedPoint: action.point
      };
    }
    case PointsActions.setPointsViewer.type: {
      return {
        ...state,
        pointsViewer: action.point
      };
    }

    default: {
      return state;
    }
  }
}

export const getPointsMap = (state: State) => state.pointsMap;
export const getPointsViewer = (state: State) => state.pointsViewer;
export const getPointsByParams = (state: State, params: any) => state.pointsMap.has(params?.unitId) ? state.pointsMap.get(params?.unitId).get(JSON.stringify({dateFrom: params?.dateFrom, dateTo: params?.dateTo})): null;
export const getPoints = (state: State) => state.points;
export const getSelectedPoint = (state: State) => state.selectedPoint;
export const arePointsLoading = (state: State) => state.pointsLoading;
